import { Spinner } from "office-ui-fabric-react";
import React, { Component } from "react";

interface LoadingCardProps {
    style?: React.CSSProperties;
    text?: string;
}

interface LoadingCardState {

}

export default class LoadingCard extends Component<LoadingCardProps, LoadingCardState>
{
    constructor(props: LoadingCardProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <div className={`cdb-table`} style={{ ...this.props.style, ...{ height: "8rem" } }}>
                <div className="card__content flex-column flex--justify-content-space-around" style={{ height: "100%" }}>
                    <div className="flex-item">
                        <Spinner label={this.props.text || "Loading..."} labelPosition="right" />
                    </div>
                </div>
            </div>
        );
    }
}